<template>
  <div class="first-ban-confirmation">
    <v-confirmation-dialog
      ref="firstBanConfirmationDialog"
      :title="$t('c.dialog.titleFirstBan')"
      :message="$t('c.dialog.messageFirstBan')"
      @confirm="nextStep"
    />
    <slot v-bind="{ step, nextStep, resetStep }" />
  </div>
</template>

<script>
import VConfirmationDialog from '@/components/common/VConfirmationDialog.vue'
import * as types from '@/store/types'

export default {
  name: 'VFirstBanConfirmationDialog',
  components: {
    VConfirmationDialog
  },
  data() {
    return {
      step: 1
    }
  },
  computed: {
    isFirstBan() {
      return this.$store.state[types.SESSION].model.user.isFirstBan
    }
  },
  methods: {
    open() {
      if (this.isFirstBan) {
        this.step = 1
        this.$refs.firstBanConfirmationDialog.open()
      } else {
        this.step = 2
      }
    },
    nextStep() {
      this.step += 1
    },
    resetStep() {
      this.step = 1
    }
  }
}
</script>
